export enum BlackWhiteListItemType {
  Whitelist = 'Whitelist',
  Blacklist = 'Blacklist'
}

export type BlackWhiteListItem<T = any> = {
  type: BlackWhiteListItemType
  items: Array<T>
}
